import { ProseMirrorEditor } from "@tento-ui/components/prosemirror";
import { SheetLispExample } from "./sheet-lisp-example.ts";

/** The editor node view that shows a formula example inside a text editor. */
export class SheetLispExampleView {
  readonly dom: SheetLispExample;

  constructor(node: ProseMirrorEditor.ProseMirrorNode) {
    this.dom = SheetLispExample.make();

    const code = node.attrs.code || "";
    const innerContent = node.attrs._innerContent || "";
    this.dom.setAttribute("code", code);
    this.dom.bind?.({ code, editable: true, configJson: innerContent });
  }

  update(node: ProseMirrorEditor.ProseMirrorNode): boolean {
    if (node.type.name !== "sheet_lisp_example") {
      return false;
    }

    const code = node.attrs.code || "";
    const innerContent = node.attrs._innerContent || "";
    if (this.dom.getAttribute("code") !== code) {
      this.dom.setAttribute("code", code);
      this.dom.bind?.({ code, editable: true, configJson: innerContent });
    }

    return true;
  }

  destroy(): void {
    this.dom.remove();
  }

  stopEvent(): boolean {
    return true;
  }

  ignoreMutation(): boolean {
    return true;
  }
}
